const JsDateString = {
    fromYMDString: function(ymdDateStr) {
        const { groups: { y, m, d } } = /(?<y>^\d{4})-0?(?<m>[\d]+)-0?(?<d>\d+)/.exec(ymdDateStr);
        return this.fromYMD(y, m-1, d);
    },
    fromYMD: (year, month, day) => `Date(${year}, ${month}, ${day})`
};

export default JsDateString;